
const ProgressChartSection = ({
  configs = [],
  selectedConfigId,
  setSelectedConfigId,
  chartData = [],
}) => {
  const handleConfigChange = (e) => {
    const id = e.target.value;
    setSelectedConfigId && setSelectedConfigId(id);
  };

  const selectedConfig = configs.find((c) => c._id === selectedConfigId);

  return (
    <div className="w-full">
      {/* Header */}
        <h3
          className="text-sm font-semibold text-center text-[#123865] mb-2"
          title={selectedConfig?.heading || ""}
        >
          {selectedConfig?.heading || "Progress Chart"}
        </h3>

      {/* Config selector (if multiple progress configs) */}
      {configs.length > 1 && (
        <div className="mt-1 mb-1 flex justify-start">
          <select
            value={selectedConfigId || ""}
            onChange={handleConfigChange}
            className="rounded-full border px-2 !py-1 text-xs text-black card-wrapper"
          >
            {configs.map((cfg) => (
              <option key={cfg._id} value={cfg._id}>
                {cfg.heading || "Untitled config"}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Progress list */}
      <div className="space-y-3 w-full bg-white/50 backdrop-blur-2xl border border-white/40 shadow-lg rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 text-[#000]">
        {chartData && chartData.length > 0 ? (
          chartData.map((item) => {
            const progress = Math.max(0, Math.min(item.value ?? 0, 100));
            const percent =
              typeof item.percent === "number" ? item.percent : progress;
            const rawCount = item.rawCount ?? 0;

            const tooltip = `${
              item.label || ""
            }\n${percent.toFixed(1)}% (${rawCount} responses)`;

            return (
              <div key={item.label} className="space-y-1">
                <div className="flex justify-between items-center">
                  <span className="truncate max-w-[60%]">
                    {item.label}
                  </span>
                  <span className="text-sky-600 font-medium">
                    {item?.value} / 100
                  </span>
                </div>

                {/* Progress bar with tooltip on hover */}
                <div
                  className="w-full h-3 bg-slate-100 rounded-full overflow-hidden cursor-pointer"
                  title={tooltip}
                >
                  <div
                    className="h-full bg-sky-500 rounded-full transition-all duration-100"
                    style={{ width: `${progress}%` }}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-[11px] text-slate-400 italic">
            No progress data available yet.
          </p>
        )}
      </div>
    </div>
  );
};

export default ProgressChartSection;
